import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const userDelete= createAsyncThunk(
  "userDelete",
  async ({userId, id}) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.delete(
        `${API_KEY}/api/user/delete-user/${userId}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          "Content-Type": "application/json",
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  userDeleteData: null,
  isError: false,
  errorMessage: "",
};

const userDeleteSlice = createSlice({
  name: "userDelete",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userDelete.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userDelete.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userDeleteData = action.payload;
    });
    builder.addCase(userDelete.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userDeleteSlice.reducer;
